import collectionPoster from '@/assets/images/winter-solace-collection.png';
export const order = 5;

export default {
  collection_name: 'Winter Solace Collection',
  collection_desc:
    'Quiet tones and grounded textures designed to bring warmth, calm, and refuge into the home',
  collection_poster: collectionPoster,
  products: [],
};
